module.exports = __webpack_public_path__ + "static/img/css.0d566e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontProJect/fangzhou/css.png
// module id = 8h55
// module chunks = 1